/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
const buttonStyles = {
    width: '40px',
    height: '40px',
    p: 0,
    textTransform: 'uppercase',
    _disabled: {
        color: 'borderGray',
        borderColor: 'borderGray',
        backgroundImage:
            'linear-gradient(to top left, white calc(50% - 1px), borderGray, white calc(50% + 1px) )',
        pointerEvents: 'none',
        cursor: 'not-allowed'
    }
}

export default {
    baseStyle: {
        shopLookDrawerButton: {
            position: {base: 'absolute', lg: 'sticky'},
            bottom: {base: '50%', lg: '-44px'},
            marginLeft: 'auto',
            marginRight: {lg: '24px'},
            right: {base: '9px', md: '24px', lg: null},
            marginBottom: {lg: '-44px'},
            zIndex: '1000',
            display: {lg: 'flex'},
            background: 'white',
            padding: {base: '8px 14px', md: '13px 20px'},
            transform: {base: 'translateY(-50%)', lg: 'translateY(calc(-30px + -100%))'},
            fontSize: {base: '12px', lg: '14px'},
            fontWeight: '600',
            fontFamily: 'Inter',
            height: '44px',
            minWidth: {base: '80px', md: 'auto'},
            maxWidth: {base: '130px', md: 'none'},
            textAlign: {base: 'left', md: 'center'}
        },
        completeLookDrawerButton: {
            position: 'absolute',
            left: '50%',
            transform: 'translate(-50%, calc(-100% - 10px))',
            top: 0,
            marginTop: '125%',
            color: 'white',
            background: 'black',
            padding: '20px'
        },
        productPrice: {
            display: {base: 'flex', md: 'flex', lg: ''},
            gap: {base: '6px', md: '6px', lg: ''}
        },
        productName: {
            fontSize: '2xl',
            textTransform: 'uppercase',
            pb: 6
        },
        sizeButtons: {
            p: '24px 0'
        },
        sizeButton: {
            ...buttonStyles,
            color: 'darkGray',
            borderColor: 'gray'
        },
        sizeButtonSelected: {
            ...buttonStyles,
            color: 'white',
            borderColor: 'black'
        }
    }
}
